export default __webpack_public_path__ + "static/media/orcloud_icon.ed594d24.png";